import React from 'react';

import { useTranslation } from 'react-i18next';

import {
  ButtonText, Card, Heading, Text,
  Button,
} from '@gluestack-ui/themed';
import { useAuthStore } from '../../../common/auth/store';

const SubmitModuleNotification = ({ visible, isSubmitted, handleSubmitModule }) => {
  const { t } = useTranslation();

  const user = useAuthStore((state) => state.user);
  const isTrial = user?.trial?.isTrial;

  if (isSubmitted) {
    return (
      <Card testID="submit-module-notification" bg="$bgSubtle" borderColor="$borderLight">
        <Heading size="sm" mb="$1">{t('student.module.module-submitted.title', 'Module Submitted')}</Heading>
        <Text size="sm">{t('student.module.module-submitted.message', 'This module has already been submitted and is currently being processed or graded.')}</Text>
      </Card>
    );
  }

  if (!visible) return null;

  return (
    <Card testID="submit-module-notification">
      <Heading mb="$3">{t('student.module.module-finished.title')}</Heading>
      <Text size="sm">{t('student.module.module-finished.message')}</Text>

      <Button
        testID="button-submit-module"
        size="sm"
        variant="solid"
        action="positive"
        alignSelf="flex-end"
        w={140}
        mt="$4"
        onPress={handleSubmitModule}
        isDisabled={isTrial}
      >
        <ButtonText>{t('student.module.current-module.button-submit-module')}</ButtonText>
      </Button>
    </Card>
  );
};

export default SubmitModuleNotification;
